import { urlQueryStringBuilder } from '@utils/constantHelpers'
import axios from '@utils/axiosInstance'
import sortOptionsByKey from '@utils/sortOptionsByKey'

const BASE = process.env.VUE_APP_BACKEND_PUBLIC_URL

const getDefaultState = () => {
  return {
    collaborator: null,
    hasCollaboratorNotifications: false,
    collaboratorsWithoutValidation: [],
    collaboratorsWithoutVacations: [],
    collaboratorDocuments: [],
    collaborators: [],
    collaboratorsBySite: {},
    fictitious: null,
    siteFictitious: [],
    teamCollaborators: null,
    deletedCollaborators: [],
    collaboratorsWithEndingContracts: [],
    civilStatus: [],
    genders: [],
    studies: [],
    sportDisciplines: [],
    sportDisciplineLevels: [],
    sportDisciplineFrequencies: [],
    collaboratorMutationProcesses: null,
    collaboratorMutationProcess: null,
    collaboratorConversionProcesses: null,
    collaboratorExtensionProcesses: null,
    dataExtraction: [],
    forthcomingContractEnd: {},
    collaboratorsBasicData: [],
    zoneDirectors: [],
    zoneDirectorSites: [],
  }
}

const statusOrder = ['PENDING_MUTATION_COLLABORATOR_PROCESS', 'CANCEL_MUTATION_COLLABORATOR_PROCESS', 'FINISH_MUTATION_COLLABORATOR_PROCESS']

const cancStatus = [
  'WAITING_FOR_COLLABORATOR_DATA',
  'WAITING_FOR_DIRECTOR_VALIDATION',
  'WAITING_FOR_DIRECTOR_AND_LEGAL_VALIDATION',
  'WAITING_FOR_HR_DATA',
  'WAITING_FOR_LEGAL_VALIDATION',
  'QUEUED_SEND_EMAIL_PENDING',
  'SCHEDULED_FOR_CONVERSION_DATE',
  'SCHEDULED_FOR_EXTENSION_DATE',
  'COMPLETED_SUCCESS',
]

export const state = getDefaultState()

export const getters = {}

export const mutations = {
  // V2
  UPDATE_CIVIL_STATUS(state, civilStatus) {
    state.civilStatus = civilStatus
  },
  UPDATE_SPORT_DISCIPLINES(state, sportDisciplines) {
    state.sportDisciplines = sportDisciplines
  },
  UPDATE_SPORT_DISCIPLINE_LEVELS(state, sportDisciplineLevels) {
    state.sportDisciplineLevels = sportDisciplineLevels
  },
  UPDATE_SPORT_DISCIPLINE_FREQUENCIES(state, sportDisciplineFrequencies) {
    state.sportDisciplineFrequencies = sportDisciplineFrequencies
  },
  UPDATE_STUDIES(state, studies) {
    state.studies = studies
  },
  /**
   * @deprecated
   * Este componente será removido en la versión 2.0.
   */
  RESET_COLLABORATOR(state) {
    state.collaborator = null
  },
  RESET_COLLABORATORS(state) {
    state.collaborators = []
  },
  RESET_EXTENSON_PROCESSES(state) {
    state.collaboratorExtensionProcesses = null
  },
  RESET_MUTATION_PROCESSES(state) {
    state.collaboratorMutationProcesses = null
  },
  UPDATE_COLLABORATOR(state, collaborator) {
    state.collaborator = collaborator
  },
  UPDATE_COLLABORATOR_NOTIFICATIONS_VISIBILITY(
    state,
    { hasCollaboratorNotifications, collaboratorsWithoutValidation, collaboratorsWithoutVacations = state.collaboratorsWithoutVacations },
  ) {
    state.hasCollaboratorNotifications = hasCollaboratorNotifications
    state.collaboratorsWithoutValidation = collaboratorsWithoutValidation
    state.collaboratorsWithoutVacations = collaboratorsWithoutVacations
  },
  UPDATE_COLLABORATORS(state, collaborators) {
    if (collaborators.length > 0) {
      sortOptionsByKey(collaborators, 'fullName')
    }
    state.collaborators = collaborators
  },
  UPDATE_COLLABORATORS_SITE(state, collaborators) {
    if (collaborators.length > 0) {
      sortOptionsByKey(collaborators, 'fullName')
    }
    state.collaboratorsBySite = collaborators
  },
  UPDATE_COLLABORATOR_DOCUMENT_LIST(state, documents) {
    state.collaboratorDocuments = documents
  },
  UPDATE_DELETED_COLLABORATORS(state, deletedCollaborators) {
    state.deletedCollaborators = deletedCollaborators
  },
  UPDATE_COLLABORATORS_WITH_ENDING_CONTRACTS(state, collaboratorsWithEndingContracts) {
    state.collaboratorsWithEndingContracts = collaboratorsWithEndingContracts
  },
  UPDATE_GENDERS(state, genders) {
    state.genders = genders
  },

  UPDATE_COLLABORATOR_CONVERSION_PROCESSES(state, collaboratorConversionProcesses) {
    state.collaboratorConversionProcesses = collaboratorConversionProcesses
  },
  UPDATE_COLLABORATOR_EXTENSION_PROCESSES(state, collaboratorExtensionProcesses) {
    state.collaboratorExtensionProcesses = collaboratorExtensionProcesses
  },
  UPDATE_COLLABORATOR_MUTATION_PROCESSES(state, collaboratorMutationProcesses) {
    state.collaboratorMutationProcesses = collaboratorMutationProcesses
  },
  UPDATE_COLLABORATOR_MUTATION_PROCESS(state, collaboratorMutationProcess) {
    state.collaboratorMutationProcess = collaboratorMutationProcess
  },
  RESET_COLLABORATOR_STATE(state) {
    Object.assign(state, getDefaultState())
  },
  UPDATE_TEAM_COLLABORATORS(state, teamCollaborators) {
    state.teamCollaborators = teamCollaborators
  },
  UPDATE_ZONE_DIRECTORS(state, zoneDirectors) {
    state.zoneDirectors = zoneDirectors
  },
  UPDATE_ZONE_DIRECTOR_SITES(state, zoneDirectorSites) {
    state.zoneDirectorSites = zoneDirectorSites
  },
}

export const actions = {
  // COLLABORATOR
  // RESET
  async resetCollaborator(store) {
    store.commit('RESET_COLLABORATOR', {})
  },
  async resetCollaborators(store) {
    store.commit('RESET_COLLABORATORS')
  },

  // GET
  // async fetchCollaborator(store, id) {
  //   try {
  //     const response = await axios.get(`${BASE}/mx/api/v2/collaborators/${id}`)
  //     store.commit('UPDATE_COLLABORATOR', response.data)
  //   } catch (error) {
  //     throw new Error(`API Error occurred at /api/collaborators/${id}.`)
  //   }
  // },

  // async fetchCollaboratorByUuid(store, collaboratorUuid) {
  //   store.commit('UPDATE_COLLABORATOR', null)
  //   try {
  //     const response = await axios.get(`${BASE}/mx/api/v2/collaborators/${collaboratorUuid}`)
  //     store.commit('UPDATE_COLLABORATOR', response.data)
  //     return response
  //   } catch (error) {
  //     throw new Error(`API Error occurred at /api/collaborators/${collaboratorUuid}.`)
  //   }
  // },

  // COLLABORATORS
  // GET
  async fetchCollaborators(store, payload) {
    store.commit('UPDATE_COLLABORATORS', [])
    let queryString = ''
    if (payload.key) {
      queryString = encodeURI(queryString + `?filter[${payload.key}]=${payload.value}`)
    }
    const url = `${BASE}/mx/api/v2/collaborators${queryString}`
    try {
      const response = await axios.get(url)
      store.commit('UPDATE_COLLABORATORS', response.data)
      return response
    } catch (error) {
      throw new Error(`API Error occurred at API Error occurred at api/collaborators.`)
    }
  },

  // TEAM COLLABORATORS & FICTITIOUS
  // GET
  async fetchTeamCollaboratorsAction(store, teamUuid) {
    store.commit('UPDATE_TEAM_COLLABORATORS', null)
    try {
      const response = await axios.get(`${BASE}/mx/api/v2/getCollaboratorsByTeam/${teamUuid}`)
      store.commit('UPDATE_TEAM_COLLABORATORS', response.data)
    } catch (error) {
      throw new Error(`API Error occurred at ${BASE}/mx/api/v2/getCollaboratorsByTeam/${teamUuid}: ${error}`)
    }
  },
  // TEAM COLLABORATORS & FICTITIOUS
  // GET
  async fetchTeamCollaboratorsWithPlanningAction(store, filters) {
    store.commit('UPDATE_TEAM_COLLABORATORS', null)

    const filtersArr = []
    Object.keys(filters).forEach((key) => {
      if (filters[key]) {
        filtersArr.push(`filter[${key}]=${filters[key]}`)
      }
    })
    const queryString = filtersArr.length > 0 ? '?' + filtersArr.join('&') : ''
    try {
      const response = await axios.get(`${BASE}/mx/planning/api/v2/PlanningManager/getCollaboratorsByTeamWithPlanning${queryString}`)
      store.commit('UPDATE_TEAM_COLLABORATORS', response.data)
    } catch (error) {
      throw new Error(`API Error occurred at ${BASE}/mx/Planning/api/v2/planningManager/getCollaboratorsByTeamWithPlanning${queryString}: ${error}`)
    }
  },
  // TEAM COLLABORATORS & FICTITIOUS
  // GET
  async fetchStoreCollaboratorsWithPlanningAction(store, filters) {
    store.commit('UPDATE_TEAM_COLLABORATORS', null)

    const filtersArr = []
    Object.keys(filters).forEach((key) => {
      if (filters[key]) {
        filtersArr.push(`filter[${key}]=${filters[key]}`)
      }
    })
    const queryString = filtersArr.length > 0 ? '?' + filtersArr.join('&') : ''
    try {
      const response = await axios.get(`${BASE}/mx/planning/api/v2/PlanningManager/getCollaboratorsBySiteWithPlanning${queryString}`)
      store.commit('UPDATE_TEAM_COLLABORATORS', response.data)
    } catch (error) {
      throw new Error(`API Error occurred at ${BASE}/mx/Planning/api/v2/planningManager/getCollaboratorsBySiteWithPlanning${queryString}: ${error}`)
    }
  },
  // DELETED COLLABORATORS
  // GET
  async fetchDeletedCollaborators(store, payload) {
    store.commit('UPDATE_DELETED_COLLABORATORS', [])
    const url = `${BASE}/mx/api/v2/contracts/collaborators.deleted${urlQueryStringBuilder(payload)}`
    try {
      const response = await axios.get(url)
      store.commit('UPDATE_DELETED_COLLABORATORS', response.data)
    } catch (error) {
      throw new Error(`API Error occurred at /mx/api/v2/contracts/collaborators.deleted${urlQueryStringBuilder(payload)}`)
    }
  },
  async cleanDeletedCollaborators(store) {
    store.commit('UPDATE_DELETED_COLLABORATORS', [])
  },
  // COLLABORATORS WITH ENDING CONTRACTS
  // GET
  async fetchCollaboratorsWithEndingContractsBySite(store, payload) {
    store.commit('UPDATE_COLLABORATORS_WITH_ENDING_CONTRACTS', [])
    try {
      const response = await axios.get(
        `${BASE}/mx/api/v2/sites/${payload.personnelDivision}/collaborators/forthcomingContractEnd?filter[daysToCheck]=${payload.daysToCheck}`,
      )
      store.commit('UPDATE_COLLABORATORS_WITH_ENDING_CONTRACTS', response.data)
    } catch (error) {
      throw new Error(
        `API Error occurred at ${BASE}/mx/api/v2/sites/${payload.personnelDivision}/collaborators/forthcomingContractEnd${payload.daysToCheck}`,
      )
    }
  },

  async fetchCollaboratorsWithEndingContractsBySiteAndTeam(store, payload) {
    store.commit('UPDATE_COLLABORATORS_WITH_ENDING_CONTRACTS', [])
    try {
      const response = await axios.get(
        `${BASE}/mx/api/v2/sites/${payload.personnelDivision}/team/${payload.teamUuid}/collaborators/forthcomingContractEnd`,
      )
      store.commit('UPDATE_COLLABORATORS_WITH_ENDING_CONTRACTS', response.data)
    } catch (error) {
      throw new Error(
        `API Error occurred at ${BASE}/mx/api/v2/sites/${payload.personnelDivision}/team/${payload.teamUuid}/collaborators/forthcomingContractEnd`,
      )
    }
  },

  // FETCH COLLABORATOR CONVERSION PROCESSES
  // GET
  async fetchCollaboratorConversionProcesses(store, payload = {}) {
    try {
      const res = await axios.get(`${BASE}/mx/api/v2/contractProcesses.common${urlQueryStringBuilder(payload)}`)
      store.commit('UPDATE_COLLABORATOR_CONVERSION_PROCESSES', res.data)
    } catch (e) {
      throw Error(`API Error occurred in contractProcesses.common`)
    }
  },
  // FETCH SITE COLLABORATOR CONVERSION PROCESSES
  // GET
  async fetchCollaboratorConversionProcessesSite(store, payload = {}) {
    try {
      const res = await axios.get(`${BASE}/mx/api/v2/sites/${payload.personnelDivision}/contractProcesses.common${urlQueryStringBuilder(payload)}`)
      store.commit('UPDATE_COLLABORATOR_CONVERSION_PROCESSES', res.data)
    } catch (e) {
      throw Error(`API Error occurred in contractProcesses.common`)
    }
  },

  async resetExtensionProcesses(store) {
    store.commit('RESET_EXTENSON_PROCESSES', {})
  },

  // FETCH COLLABORATOR EXTENSION PROCESSES
  // GET
  async fetchCollaboratorExtensionProcesses(store, payload = {}) {
    try {
      const res = await axios.get(`${BASE}/mx/api/v2/contractProcesses.common${urlQueryStringBuilder(payload)}`)
      store.commit('UPDATE_COLLABORATOR_EXTENSION_PROCESSES', res.data)
    } catch (e) {
      throw Error(`API Error occurred in contractProcesses.common`)
    }
  },
  // FETCH SITE COLLABORATOR EXTENSION PROCESSES
  // GET
  async fetchCollaboratorExtensionProcessesSite(store, payload = {}) {
    try {
      const res = await axios.get(`${BASE}/mx/api/v2/sites/${payload.personnelDivision}/contractProcesses.common${urlQueryStringBuilder(payload)}`)
      store.commit('UPDATE_COLLABORATOR_EXTENSION_PROCESSES', res.data)
      if (res.data.data.length >= 1) {
        const arr = res.data.data
        arr.sort((a, b) => {
          return cancStatus.indexOf(a.currentStatus) - cancStatus.indexOf(b.currentStatus)
        })

        return arr
      }
    } catch (e) {
      throw Error(`API Error occurred in contractProcesses.common`)
    }
  },

  async resetMutationProcesses(store) {
    store.commit('RESET_MUTATION_PROCESSES', {})
  },

  // COLLABORATOR MUTATION PROCESS
  // GET
  async fetchCollaboratorMutationProcess(store, processUuid) {
    try {
      const res = await axios.get(`${BASE}/mx/api/v2/mutationsProcess/${processUuid}`)
      store.commit('UPDATE_COLLABORATOR_MUTATION_PROCESS', res.data)
    } catch (error) {
      throw new Error(`API Error occurred in ${BASE}/mx/api/v2/mutationsProcess/${processUuid}`)
    }
  },
  // FETCH COLLABORATOR MUTATION PROCESSES
  // GET
  async fetchCollaboratorMutationProcesses(store, filters) {
    const url = `${BASE}/mx/api/v2/mutationsProcess${urlQueryStringBuilder(filters)}`
    try {
      const res = await axios.get(url)
      store.commit('UPDATE_COLLABORATOR_MUTATION_PROCESSES', res.data)
    } catch (e) {
      throw Error(`API Error occurred in ${url}`)
    }
  },
  // FETCH SITE COLLABORATOR MUTATION PROCESSES
  // GET
  async fetchCollaboratorMutationProcessesSite(store, payload) {
    const url = `${BASE}/mx/api/v2/sites/${payload.personnelDivision}/mutationsProcess`
    try {
      const res = await axios.get(url)
      store.commit('UPDATE_COLLABORATOR_MUTATION_PROCESSES', res.data)
      if (res.data.data.length >= 1) {
        const arr = res.data.data
        arr.sort((a, b) => {
          return statusOrder.indexOf(a.currentStatus) - statusOrder.indexOf(b.currentStatus)
        })

        return arr
      }
    } catch (e) {
      throw Error(`API Error occurred in ${url}`)
    }
  },
  // async fetchCollaboratorDocumentList(store, collaboratorUuid) {
  //   const url = `${BASE}/mx/api/v2/document/` + collaboratorUuid

  //   try {
  //     const res = await axios.get(url)
  //     store.commit('UPDATE_COLLABORATOR_DOCUMENT_LIST', res.data)
  //   } catch (error) {
  //     throw new Error(`API Error occurred in ${url}`)
  //   }
  // },

  // /////////
  // POST
  // /////////

  // UPDATE COLLABORATOR PERSONAL DATA
  // POST
  async updateCollaboratorPersonalDataAction({ store }, payload) {
    try {
      return await axios.post(`${BASE}/mx/api/v2/collaborators/edit.personalData`, payload)
    } catch (e) {
      throw Error(`API Error occurred at /mx/api/v2/collaborators/edit.personalData`)
    }
  },

  async updateCollaboratorAddressDataAction({ store }, payload) {
    try {
      return await axios.post(`${BASE}/mx/api/v2/collaborators/edit.addressData`, payload)
    } catch (e) {
      throw Error(`API Error occurred at /mx/api/v2/collaborators/edit.addressData`)
    }
  },

  async updateCollaboratorFiscalDataAction({ store }, payload) {
    try {
      return await axios.post(`${BASE}/mx/api/v2/collaborators/edit.fiscalData`, payload)
    } catch (e) {
      throw Error(`API Error occurred at /mx/api/v2/collaborators/edit.fiscalData`)
    }
  },

  async updateCollaboratorBankDataAction({ store }, payload) {
    try {
      return await axios.post(`${BASE}/mx/api/v2/collaborators/edit.bankData`, payload)
    } catch (e) {
      throw Error(`API Error occurred at /mx/api/v2/collaborators/edit.bankData`)
    }
  },

  async updateCollaboratorLaborDataAction({ store }, payload) {
    try {
      return await axios.post(`${BASE}/mx/api/v2/collaborators/edit.laborData`, payload)
    } catch (e) {
      throw Error(`API Error occurred at /mx/api/v2/collaborators/edit.laborData`)
    }
  },

  // UPDATE COLLABORATOR SENSITIVE PERSONAL DATA
  // POST
  async updateCollaboratorSensitivePersonalDataAction({ store }, payload) {
    try {
      return await axios.post(`${BASE}/mx/api/v2/collaborators/edit.sensitivePersonalData`, payload)
    } catch (e) {
      throw Error(`API Error occurred at /mx/api/v2/collaborators/edit.sensitivePersonalData`)
    }
  },
  // UPDATE COLLABORATOR LEGAL TUTOR DATA
  // POST
  async updateLegalTutorDataAction({ store }, payload) {
    try {
      return await axios.post(`${BASE}/mx/api/v2/collaborators/edit.legalTutorData`, payload)
    } catch (e) {
      throw Error(`API Error occurred at /mx/api/v2/collaborators/edit.legalTutorData`)
    }
  },
  // UPDATE COLLABORATOR ABILITY DATA
  // POST
  async updateAbilityDataAction({ store }, payload) {
    try {
      return await axios.post(`${BASE}/mx/api/v2/collaborators/edit.personalAbilitiesData`, payload)
    } catch (e) {
      throw Error(`API Error occurred at /mx/api/v2/collaborators/edit.personalAbilitiesData`)
    }
  },
  // START COLLABORATOR MUTATION PROCESS
  // POST
  async collaboratorMutationActionStart({ store }, payload) {
    try {
      return await axios.post(`${BASE}/mx/api/v2/contractManager/mutation.startMutationProcess`, payload)
    } catch (e) {
      throw Error(`API Error occurred at /mx/api/v2/contractManager/mutation.startMutationProcess`)
    }
  },
  // UPDATE COLLABORATOR MUTATION PROCESS
  // POST
  async collaboratorMutationActionUpdate({ store }, payload) {
    try {
      return await axios.post(`${BASE}/mx/api/v2/contractManager/mutation.updateMutationProcess`, payload)
    } catch (e) {
      throw Error(`API Error occurred at /mx/api/v2/contractManager/mutation.updateMutationProcess`)
    }
  },
  // CANCELL MUTATION PROCESS
  // POST
  async cancelMutationContractProcessAction({ store }, payload) {
    try {
      return await axios.post(`${BASE}/mx/api/v2/contractManager/mutation.cancelMutationProcess`, payload)
    } catch (e) {
      throw Error(`API Error occurred at /mx/api/v2/collaborators/mutation.cancelMutationProcess`)
    }
  },
  async fetchZoneDirectors(store) {
    try {
      const res = await axios.get(`${BASE}/mx/api/v2/collaborators/zoneDirectors`)
      store.commit('UPDATE_ZONE_DIRECTORS', res.data)
    } catch (e) {
      throw Error(`API error occured at /mx/api/v2/collaborators/zoneDirectors: ${e}`)
    }
  },
  async getZoneDirectorSites(store, collaboratorUuid) {
    try {
      const res = await axios.get(`${BASE}/mx/api/v2/collaborators/zoneDirectors/sites/${collaboratorUuid}`)
      store.commit('UPDATE_ZONE_DIRECTOR_SITES', res.data.sites)
    } catch (e) {
      throw Error(`API error occured at /mx/api/v2/collaborators/zoneDirectors/sites/: ${e}`)
    }
  },
  async updateZoneDirectorSites(store, payload) {
    const url = `${BASE}/mx/api/v2/collaborators/zoneDirectors/sites/update`
    try {
      return await axios.post(url, payload)
    } catch (e) {
      throw Error(`API Error occurred at ${url}.`)
    }
  },
}
